import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import { isEmpty } from 'lodash';

import Charts from '../../../components/Charts';
import Table from '../../../components/Table';

import { rowsPerPageOptions } from '../../../utils/defaultData';
import { defaultProps, propTypes } from './propTypes';

const CatalogBody = (props) => {
  const {
    loading, list, chart, listTotal, tableHeader, selectedError, table,
  } = props;
  let extra = {};
  if (chart.selected && !isEmpty(chart.selected)) {
    extra = {
      title: 'text.errorsType',
      subtitle: 'text.mapping',
    };
  }

  return (
    <>
      <div className="section-block min-h-lg">
        {loading.charts && (
          <div className="pos-abs full section-loader">
            <LinearProgress />
          </div>
        )}
        <Charts
          chartList={chart.list}
          loading={loading.charts}
          selected={chart.selected}
          deleteSelected={chart.onDelete}
          onChartClick={chart.onClick}
        />
      </div>
      <Table
        extra={extra}
        extraActions={table.extraActions}
        loading={loading.logs}
        list={list}
        tableHeader={tableHeader}
        total={listTotal}
        onTableRowClick={props.onTableRowClick}
        onPaginationChange={props.onPaginationChange}
        selectedError={selectedError}
        onErrorDetailsClose={props.onErrorDetailsClose}
        pagination={{
          rowsPerPageOptions,
          data: props.pagination,
        }}
      />
    </>
  );
};

CatalogBody.propTypes = propTypes;
CatalogBody.defaultProps = defaultProps;

export default CatalogBody;
